import { activeTabActions } from '../../services';

export const activeTabDispatcher = dispatch => ( {
  setTab: ( tab, title ) => dispatch( { type: activeTabActions.SET, tab, title } )
} );